import { firestore } from '@/firebaseConfig'
import User from '@/model/User';
import { BaseService } from './BaseService';


export default class UserService extends BaseService {
    loadUser(userId) {
        const promise = new Promise((resolve, reject) => {
            firestore.collection("users").doc(userId).get().then((doc) => {
                if (doc.exists) {
                    resolve(new User(doc.data()));
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadUsersEmailByIds(uids) {
        if (!uids || uids.length === 0) {
            return Promise.resolve(null);
        }
        const promise = new Promise((resolve, reject) => {
            const uidsString = uids.join(',');
            this.getFromAPI("/users/uids/" + uidsString).then((data) => {
                if (data) {
                    resolve(data);
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    loadUsersIdsByEmails(emails) {
        if (!emails || emails.length === 0) {
            return Promise.resolve(null);
        }
        const promise = new Promise((resolve, reject) => {
            const emailsString = emails.join(',');
            this.getFromAPI("/users/emails/" + emailsString).then((data) => {
                if (data) {
                    resolve(data);
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                console.error("Error loading user IDs by emails:", error);
                reject(error);
            });
        });

        return promise;
    }

    loadUsersForGroupIds(groupIds) {
        if (!groupIds || groupIds.length === 0) {
            return Promise.resolve(null);
        }
        const promise = new Promise((resolve, reject) => {
            const groupIdsString = groupIds.join(',');
            this.getFromAPI("/users/groupIds/" + groupIdsString).then((data) => {
                if (data) {
                    resolve(data);
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    createUser(email) {
        return this.postToAPI('/users/create', { email });
    }

    saveUser(userId, user) {
        return this.putToAPI('/users/' + userId + '/profile', {
            phoneNumber: user.phoneNumber || "",
            notifyViaAppNotification: user.notifyViaAppNotification || false,
            notifyViaEmail: user.notifyViaEmail || false,
            notifyViaSMS: user.notifyViaSMS || false,
            groupIds: user.groupIds || {}
        });
    }

    disableGroupIds(userId, groupIds) {
        if (!groupIds || Object.keys(groupIds).length === 0) {
            return Promise.resolve();
        }
        const disabledGroupIds = {};
        Object.keys(groupIds).forEach((key) => {
            disabledGroupIds[key] = false;
        });
        return this.putToAPI('/users/' + userId + '/profile', { groupIds: disabledGroupIds });
    }

    updateOndagoPlus(userId, enabled) {
        return this.putToAPI('/users/' + userId + '/ondagoplus', { enabled });
    }
}
